import Vue from 'vue'
import VueRouter, { RouterView } from 'vue-router'
import store from "@/store";
import { locationSearchCode, handleLocationSearch } from './tool'
import { getWechatAccessToken } from '@/apis/wx.api';
import { storeSet, storeGet } from '@/utils/localStore';
import { getBindingUserIdApi, getIPAddr } from '@/apis/common.api';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    children: [
      
    ]
  },
  {
    path: '/clockIn',
    name: 'clockIn',
    component: () => import(/* webpackChunkName: "clockIn" */'../views/clockIn'),
    meta: { title: '签到活动' }, 
  },
  {
    path: '/giftCenter',
    name: 'giftCenter',
    component: () => import(/* webpackChunkName: "giftCenter" */'../views/giftCenter'),
    meta: { title: '新人惊喜' },  // 20250807 礼包中心改名为新人惊喜
  },
  {
    path: '/myGift',
    name: 'myGift',
    component: () => import(/* webpackChunkName: "myGift" */'../views/giftCenter/myGift'),
    meta: { title: '我的礼包' }, 
  },
  {
    path: '/gameCenter',
    name: 'gameCenter',
    component: () => import(/* webpackChunkName: "gameCenter" */'../views/gameCenter'),
    meta: { title: '在线玩' }, 
  },
  {
    path: '/payAmount',
    name: 'payAmount',
    component: () => import(/* webpackChunkName: "payAmount" */'../views/payAmount'),
    meta: { title: '累充活动' }, 
  },
  {
    path: '/accountBind',
    name: 'accountBind',
    component: () => import(/* webpackChunkName: "accountBind" */'../views/account/bind.vue'),
    meta: { title: '角色确认' }, 
  },
  {
    path: '/accountBindInQWTP',
    name: 'accountBindInQWTP',
    component: () => import(/* webpackChunkName: "qiWeiTransferPromote" */'../views/qiweiMiniGame/transferPromote/bind.vue'),
    meta: { title: '角色确认' }, 
  },
  {
    path: '/promote',
    name: 'promote',
    component: () => import(/* webpackChunkName: "accountBind" */'../views/promoteOrder/index.vue'),
    meta: { title: '活动' }, // 促单活动 
  },
  {
    path: '/promoteBind',
    name: 'promoteBind',
    component: () => import(/* webpackChunkName: "accountBind" */'../views/promoteOrder/bind.vue'),
    meta: { title: '角色确认' }, // 促单活动角色绑定
  },
  {
    path: '/qwWxGameActivity',
    name: 'qwWxGameActivity',
    component: () => import(/* webpackChunkName: "qwWxGameActivity" */'../views/qiweiMiniGame/qiweiMiniGame.vue'),
    meta: { title: '微信小游戏用户企微承接' }, 
  },
  // 企微小游戏转游活动 
  {
    path: '/qywxGameTransfer',
    name: 'qywxGameTransfer',
    component: () => import(/* webpackChunkName: "qywxGameTransfer" */'../views/qiweiMiniGame/qywxGameTransfer.vue'),
    meta: { title: '企微小游戏转游活动' }, 
  },
  
  {
    path: '/middleJumpPage',
    name: 'middleJumpPage',
    component: () => import(/* webpackChunkName: "middleJumpPage" */'../views/qiweiMiniGame/middleJumpPage.vue'),
    meta: { title: '跳转' }, 
  },

  {
    path: '/turnable',
    name: 'turnable',
    component: () => import(/* webpackChunkName: "turnable" */'../views/wheelLottery/index.vue'),
    meta: { title: '转盘抽奖' }, 
  },
  // 企微小游戏转游促单活动 
  {
    path: '/qiWeiTransferPromote',
    name: 'qiWeiTransferPromote',
    component: () => import(/* webpackChunkName: "qiWeiTransferPromote" */'../views/qiweiMiniGame/transferPromote/index.vue'),
    meta: { title: '转游活动' },
  },
  {
    path: '/actAfterCall',
    name: 'actAfterCall',
    component: () => import(/* webpackChunkName: "qiWeiRecallMaintain" */'../views/qiweiMiniGame/actAfterCall/index.vue'),
    meta: { title: '活动' }, // 企微召回后维护活动 
  },
  // 微信静默授权中转页面
  {
    path: '/wx-silent-login',
    name: 'wxSilentLogin',
    component: () => import(/* webpackChunkName: "wxAuth" */'../views/wxAuth/SilentLogin.vue'),
    meta: { 
      title: '微信授权中',
      noAuth: true  // 标记不需要进行路由守卫的微信授权
    }, 
  },
  {
    path: '/wx-redirect',
    name: 'wxRedirect',
    component: () => import(/* webpackChunkName: "wxAuth" */'../views/wxAuth/Redirect.vue'),
    meta: { 
      title: '授权成功',
      noAuth: true  // 标记不需要进行路由守卫的微信授权
    }, 
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const HANDLE_MOCK_DATA = () => {
  storeSet('WX_APP_ID', 'wx5e3815b7f3f113b5')
  storeSet('wxAuthQuery', {"wx_app_id":"wx5e3815b7f3f113b5","activityId":"17", "gameId": "10017"}, true)
  storeSet('OPEN_ID', 'olEMh57JnUUby3iaBH0oHnJZGhIs')
}

const getBindUser = async (wxappid) => {
// 获取绑定用户id
  const res2 = await getBindingUserIdApi({ wxappid: wxappid, openid: store.getters['user/openid'] })
  store.commit('user/UPDATE_U_ID', res2.data.uid || '')
  store.commit('user/UPDATE_GAME_USER_NAME', res2.data.syUsername || '')
}

router.beforeEach(async (to, from, next) => {
  // 如果是微信授权中转页面，直接放行，不进行授权检查 
  if (to.meta.noAuth) {
    next();
    return;
  }
  
  const open_id = store.getters['user/openid']
  console.log('store.state.user-->', store.getters['user/openid'])
  const { code, wx_app_id } = to.query;
  const { wx_app_id: store_wx_app_id } = storeGet('wxAuthQuery', true) || {}
  const new_wx_app_id = wx_app_id || store_wx_app_id
  const storeWxAppId = storeGet('WX_APP_ID')
  const wxIdChanged = !storeWxAppId || (new_wx_app_id && new_wx_app_id !== storeWxAppId)

  const params_app_id = new_wx_app_id || storeWxAppId
  // 缓存内没值或者值不是最新 --> 更新本地缓存的微信公众号id

  getIPAddr()
    .then(response => {
      return response.text()
    })
    .then(ip => {
      storeSet('IP_ADDR', ip)
    })

  // 1. 先判断 store 中有无userInfo 且 userInfo 是本微信公众号的
  if (open_id && !wxIdChanged) {
    console.log("用户信息存在 -->", open_id);
    // const uid = store.getters['user/uid']
    // if (!uid) {
      getBindUser(params_app_id).finally(() => {
        next()
      })
    // } else {
      // next()
    // }
    return
  }

  // 2. 没有登录信息也没有授权 code
  if (!code) {
    const redirect_uri = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}?wx_app_id=${params_app_id}`);
    localStorage.setItem('wxAuthQuery', JSON.stringify(to.query));
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${params_app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
    return
  } else {
    // 对被微信拼接了code参数的url处理下 处理掉code
    const _url = window.location.origin + window.location.pathname;
    // 获取微信授权信息
    const res = await getWechatAccessToken({
      code,
      wxappid: params_app_id,
    })
    store.commit('user/UPDATE_USER_INFO', res.data)

    // 获取绑定用户id
    getBindUser(params_app_id).finally(() => {
      window.history.replaceState({}, 0, _url)
      next()
    })
  }

  if (wxIdChanged) {
    storeSet('WX_APP_ID', params_app_id || '')
  }
})

router.afterEach((to, from) => {
  document.title = to.meta.title
})

export default router
